"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
module.exports = __toCommonJS(index_exports);
__reExport(index_exports, require("./extensions"), module.exports);
__reExport(index_exports, require("@hcengineering/text-core"), module.exports);
__reExport(index_exports, require("./nodes"), module.exports);
__reExport(index_exports, require("./markup/utils"), module.exports);
__reExport(index_exports, require("./marks/code"), module.exports);
__reExport(index_exports, require("./marks/colors"), module.exports);
__reExport(index_exports, require("./marks/noteBase"), module.exports);
__reExport(index_exports, require("./marks/inlineComment"), module.exports);
__reExport(index_exports, require("./kits/common-kit"), module.exports);
__reExport(index_exports, require("./kits/server-kit"), module.exports);
__reExport(index_exports, require("./kit"), module.exports);
__reExport(index_exports, require("./tiptapExtensions"), module.exports);
//# sourceMappingURL=index.js.map
